/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { MENU_ITEMS } from './pages/pages-menu';
import { NavigationEnd, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';

@Component({
  selector: 'ngx-app',
  template: `
  <ng-container *ngIf="isLoginPage; else mainLayout">
    <router-outlet></router-outlet>
  </ng-container>
  <ng-template #mainLayout>
    <ngx-one-column-layout>
      <nb-menu [items]="menu" autoCollapse="true"></nb-menu>
        <router-outlet></router-outlet>
    </ngx-one-column-layout>
  </ng-template>

      
  `,
})
export class AppComponent implements OnInit, AfterViewInit {
  menu = MENU_ITEMS;
  isLoginPage = false;

  constructor(private analytics: AnalyticsService, private seoService: SeoService, private router: Router,private menuService:NbMenuService
    ) {
  }

  ngAfterViewInit() {
    const windowModeElements = document.querySelectorAll('.window-mode');
    windowModeElements.forEach(element => {
      element.classList.remove('window-mode');
    });
   
  }
  
  ngOnInit(): void {
    console.log('collpa')
    this.menuService.collapseAll();
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isLoginPage = event.url === '/';
      }
    });
  }
}
